import type { ObjectValues } from './generic';

export const errorMessageCodes = {
  EMAIL_EXISTS: 'EMAIL_EXISTS',
  PHONE_EXISTS: 'PHONE_EXISTS',
  INVALID_PHOTO_URL: 'INVALID_PHOTO_URL',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  TOKEN_REVOKED: 'TOKEN_REVOKED',
  TOKEN_INVALID: 'TOKEN_INVALID',
  NOTIFICATION_TOKEN_NOT_SET: 'NOTIFICATION_TOKEN_NOT_SET',
  UNAUTHORIZED: 'UNAUTHORIZED',
  ENTITY_IN_USE: 'ENTITY_IN_USE',
  CANNOT_DELETE_LAST_BANK_ADMIN: 'CANNOT_DELETE_LAST_BANK_ADMIN',
} as const;

export type ErrorMessageCodesType = ObjectValues<typeof errorMessageCodes>;
